import { render, staticRenderFns } from "./krasRiskTab.vue?vue&type=template&id=38dbd65e"
import script from "./krasRiskTab.vue?vue&type=script&lang=js"
export * from "./krasRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dbd65e')) {
      api.createRecord('38dbd65e', component.options)
    } else {
      api.reload('38dbd65e', component.options)
    }
    module.hot.accept("./krasRiskTab.vue?vue&type=template&id=38dbd65e", function () {
      api.rerender('38dbd65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/risk/krasRiskTab.vue"
export default component.exports